import { React, PT } from '@gasbuddy/react';
import { Grid, Input } from 'semantic-ui-react';
import { BrandLogo, BrandEditDetails } from '..';

export const BrandEdit = ({ brand, editHandler }) => (
  <Grid columns={2} textAlign="center">
    <Grid.Row>
      <Grid.Column width={1}>
        <BrandLogo brand={brand} size="Large" />
      </Grid.Column>
      <Grid.Column width={1}>
        <Input defaultValue={brand.name} placeholder={brand.name ? '' : 'Enter Brand Name...'} onChange={editHandler('name', 'string')} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <BrandEditDetails brand={brand} editHandler={editHandler} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

BrandEdit.defaultProps = {
  brand: {
    brandId: null,
    imageUrl: '',
    name: 'Unknown',
  },
  editHandler: () => {},
};

BrandEdit.propTypes = {
  brand: PT.shape(
    {
      brand_id: PT.number,
      name: PT.string,
      logo_version: PT.number,
      is_cstore: PT.boolean,
      is_fuel: PT.boolean,
      allow_brand_sharing: PT.boolean,
      display: PT.boolean,
    },
  ),
  editHandler: PT.func,
};
